<template>
    <v-container fluid grid-list-sm align-start>
        <v-flex xs12>
            <v-card>
                <v-container fluid grid-list-lg align-start>
                    <v-form v-model="valid">
                        <v-layout row wrap>
                            <v-flex xs12 v-if="starterRegistration.starter">
                                <h2 v-text="starterRegistration.starter.name"></h2>
                            </v-flex>

                            <v-flex xs12 :sm6="starterRegistration.starter_style_id">
                                <v-autocomplete
                                        :items="filteredAgeGroups"
                                        v-model="starterRegistration.age_group_id"
                                        :label="$t('age_group')"
                                        item-value="id"
                                        item-text="name"
                                        :loading="loading"
                                        :rules="rules.age_group"
                                        :disabled="loading"
                                >
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm6 v-if="starterRegistration.starter_style_id">
                                <v-autocomplete
                                        :items="filteredStarterStyles"
                                        v-model="starterRegistration.starter_style_id"
                                        :label="$t('starter_style')"
                                        item-value="id"
                                        item-text="name"
                                        :loading="loading"
                                        :disabled="loading || starterRegistration.starter_style_id === null"
                                >
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs6 sm4 md3
                                    v-for="(member, index) in starterRegistration.starter_member_registrations" :key="member.id"
                            >
                                <h3>{{ (index+1) + '. ' + member.starter_member.first_name + ' ' + member.starter_member.last_name }}</h3>

                                <v-text-field
                                        :label="$t('price')"
                                        v-model="member.price"
                                        :rules="rules.price"
                                        :disabled="loading"
                                        suffix="ct"
                                        @keyup.enter="submit"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-btn class="right mx-0" color="primary" @click="submit" :disabled="!valid || loading">{{ $t('save') }}</v-btn>
                                <v-btn class="mx-0" flat :disabled="loading" @click="cancel">{{ $t('cancel') }}</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-container>
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            id: {
                type: Number,
                default: null
            }
        },
        data () {
            return {
                $validates: true,
                valid: false,
                loading: false,
                starterRegistration: {
                    name: null,
                    age_group_id: null,
                    starter_style_id: null,
                    starter_member_registrations: []
                },
                rules: {
                    age_group: [
                        (v) => !!v || 'Altersklasse fehlt'
                    ],
                    price: [
                        (v) => !!v || 'Preis fehlt'
                    ]
                }
            }
        },
        computed: {
            filteredAgeGroups() {
                return _.filter(this.ageGroups.items, a => this.starterRegistration.starter !== undefined && this.starterRegistration.starter.event !== undefined && a.event_rule_id === this.starterRegistration.starter.event.event_rule_id);
            },
            filteredStarterStyles() {
                return _.filter(this.starterStyles.items, s => this.starterRegistration.starter !== undefined && this.starterRegistration.starter.event !== undefined && s.event_rule_id === this.starterRegistration.starter.event.event_rule_id);
            },
            ...mapState(['ageGroups', 'starterStyles'])
        },
        mounted() {
            if (this.id) {
                this.loadStarterRegistration(this.id);
            }
        },
        methods: {
            loadStarterRegistration(id) {
                this.loading = true;

                this.starterRegistration.id = parseInt(id);

                axios.get(`/api/v1/starter_registrations/${id}`).then(response => {

                    if (!response.data.success) {
                        return;
                    }

                    this.$set(this, 'starterRegistration', response.data.data);

                    this.loading = false;
                }, errorResponse => {
                    console.log(errorResponse);
                    this.loading = false;
                });
            },
            submit () {
                if (!this.valid) {
                    console.log('not valid');
                    return;
                }

                this.loading = true;

                axios.put(`/api/v1/starter_registrations/${this.starterRegistration.id}`, this.starterRegistration).then(response => {

                    if (!response.data.success) {
                        return;
                    }

                    this.loading = false;

                    this.$router.push(`/event-reports/${this.starterRegistration.starter.event_id}`);

                    this.$store.commit('snackBar', {
                        color: 'success',
                        text: this.$t('was_saved', [this.starterRegistration.starter.name])
                    });

                }, errorResponse => {
                    console.log(errorResponse);
                    this.loading = false;
                });
            },
            cancel () {
                this.$router.go(-1);
            }
        }
    }
</script>
